export default "__VITE_ASSET__DFxirKxp__"